import React from 'react';
import './public/site.css';
import PublicHeader from './public/PublicHeader';
import PublicFooter from './public/PublicFooter';

const PrivacyEN: React.FC = () => {
  React.useEffect(() => {
    document.title = 'Privacy Policy - Fconnect';
  }, []);
  return (
    <div className="home-page fc-site">
      <PublicHeader lang="en" />

      {/* Content */}
      <section className="home-container">
        <header className="privacy-header">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString('en-US')}</p>
        </header>
        <div className="privacy-content">
          <section className="privacy-section">
            <h2>1. Introduction</h2>
            <p>
              Welcome to Fconnect! We are committed to protecting your privacy and personal information.
              This Policy explains how we collect, use, store, and protect your information when you use our services.
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. Information we collect</h2>
            <h3>2.1 Personal information</h3>
            <ul>
              <li>Full name, email address, phone number</li>
              <li>Shipping and billing address</li>
              <li>Account information and password</li>
              <li>Avatar and profile information</li>
            </ul>

            <h3>2.2 Transaction information</h3>
            <ul>
              <li>Order and payment history</li>
              <li>Services you have used</li>
              <li>Ratings and reviews</li>
              <li>Communications with service providers</li>
            </ul>

            <h3>2.3 Technical information</h3>
            <ul>
              <li>IP address and geolocation</li>
              <li>Device and browser information</li>
              <li>Cookies and usage data</li>
              <li>App activity logs</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. How we use your information</h2>
            <ul>
              <li><strong>Provide services:</strong> Process orders, connect with providers, and support customers</li>
              <li><strong>Improve services:</strong> Analyze usage behavior and develop new features</li>
              <li><strong>Security:</strong> Prevent fraud and protect user accounts</li>
              <li><strong>Marketing:</strong> Send promotions and news (with your consent)</li>
              <li><strong>Legal compliance:</strong> Respond to lawful requests from authorities</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4. Sharing your information</h2>
            <p>We only share your information in the following cases:</p>
            <ul>
              <li><strong>With service providers:</strong> To fulfill the services you ordered</li>
              <li><strong>With payment partners:</strong> To process financial transactions</li>
              <li><strong>With law enforcement:</strong> When required by law</li>
              <li><strong>In emergencies:</strong> To protect user safety</li>
            </ul>
            <p>
              <strong>We do not sell, rent, or trade your personal information to third parties for commercial purposes.</strong>
            </p>
          </section>

          <section className="privacy-section">
            <h2>5. Information security</h2>
            <p>We apply industry-standard security measures to protect your information:</p>
            <ul>
              <li>SSL/TLS encryption for all data in transit</li>
              <li>Encryption of sensitive data at rest</li>
              <li>Multi-factor authentication for critical accounts</li>
              <li>Strict access control for staff</li>
              <li>Regular and secure backups</li>
              <li>24/7 security monitoring</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>6. Your rights</h2>
            <p>You have the following rights over your personal information:</p>
            <ul>
              <li><strong>Access:</strong> View the personal information we store</li>
              <li><strong>Rectification:</strong> Update or correct inaccurate information</li>
              <li><strong>Erasure:</strong> Request deletion of personal information (in certain cases)</li>
              <li><strong>Restriction:</strong> Limit how we process your information</li>
              <li><strong>Portability:</strong> Receive a copy of your data in a structured format</li>
              <li><strong>Objection:</strong> Object to processing for marketing purposes</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>7. Cookies and tracking technologies</h2>
            <p>We use cookies and similar technologies to:</p>
            <ul>
              <li>Remember your login and preferences</li>
              <li>Analyze website and app usage</li>
              <li>Personalize content and ads</li>
              <li>Improve performance and user experience</li>
            </ul>
            <p>
              You can manage cookies via your browser settings. Disabling cookies may affect service functionality.
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. Data retention</h2>
            <p>We retain your information:</p>
            <ul>
              <li>For as long as you use the services</li>
              <li>For a reasonable period after you stop using them</li>
              <li>As required by applicable data retention laws</li>
              <li>Until you request deletion (where permitted)</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>9. Children and privacy</h2>
            <p>
              Our services are not intended for children under 13. We do not knowingly collect personal
              information from children under 13. If we discover such collection, we will delete it immediately.
            </p>
          </section>

          <section className="privacy-section">
            <h2>10. Policy updates</h2>
            <p>
              We may update this Policy from time to time. For significant changes, we will notify you via email or in-app notifications.
              Your continued use of the services after changes means you accept the new Policy.
            </p>
          </section>

          <section className="privacy-section">
            <h2>11. Contact</h2>
            <p>
              If you have questions about this Policy or wish to exercise your rights, please contact us:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> trile@fconnect.vn</p>
              <p><strong>Phone:</strong> 02513684266</p>
              <p><strong>Address:</strong> 11/4C, To 15, Kp 6, Nguyen Ai Quoc Street, Tran Bien Ward, Dong Nai City, Vietnam</p>
              <p><strong>Support hours:</strong> 8:00 - 22:00 (Mon - Sun)</p>
            </div>
          </section>
        </div>
      </section>

      <PublicFooter lang="en" />
    </div>
  );
};

export default PrivacyEN;


